<div class="user-service-datetime">
  <div class="step-title strong">
    {{'teacher-card.select-date-time' | customLocale}}
  </div>
  <clock-spinner *ngIf="models?.calendar.loading"></clock-spinner>
  <app-datetime-picker
    *ngIf="teacherData && _me && !models?.calendar.loading"
    [me]="_me"
    [events]="models.calendar.events"
    [min]="min_date"
    [max]="max_date"
    [user_id]="teacherData.id"
    [timePicker]="true"
    [noTime]="teacherDontHaveTime"
    (periodChanged)="onCalendarPeriodChanged($event)"
    (selected)="onTimeSelected($event)"
    (closeFull)="closeWindow()"></app-datetime-picker>
</div>
